const en = {
  listTitle: 'All workflows',
  addButton: 'Add a workflow',
  lastUpdated: 'Last modified',
};

export default en;
export type Translations = typeof en;
